'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _freeBrandsSvgIcons = require('@fortawesome/free-brands-svg-icons');

require('./social-media-buttons.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var iconMap = {
  facebook: _freeBrandsSvgIcons.faFacebook,
  instagram: _freeBrandsSvgIcons.faInstagram,
  twitter: _freeBrandsSvgIcons.faTwitter,
  linkedin: _freeBrandsSvgIcons.faLinkedin,
  github: _freeBrandsSvgIcons.faGithub,
  yelp: _freeBrandsSvgIcons.faYelp
};

var SocialMediaButtons = function (_React$Component) {
  _inherits(SocialMediaButtons, _React$Component);

  function SocialMediaButtons() {
    _classCallCheck(this, SocialMediaButtons);

    return _possibleConstructorReturn(this, (SocialMediaButtons.__proto__ || Object.getPrototypeOf(SocialMediaButtons)).apply(this, arguments));
  }

  _createClass(SocialMediaButtons, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          containerClassName = _props.containerClassName,
          buttonClassName = _props.buttonClassName,
          socialMediaConfig = _props.socialMediaConfig;

      return _react2.default.createElement(
        'div',
        { id: 'social-media-container', className: containerClassName },
        socialMediaConfig.map(function (platform) {
          return _react2.default.createElement(
            'button',
            {
              key: platform.type,
              disabled: !platform.link,
              className: buttonClassName,
              id: 'social-media-btns-link',
              style: !platform.link ? { cursor: 'default' } : {}
            },
            _react2.default.createElement(
              'a',
              {
                href: platform.link,
                target: '_blank',
                rel: 'noopener',
                style: !platform.link ? { pointerEvents: 'none', opacity: 0.5 } : {}
              },
              _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: iconMap[platform.type], size: '2x' })
            )
          );
        })
      );
    }
  }]);

  return SocialMediaButtons;
}(_react2.default.Component);

exports.default = SocialMediaButtons;


SocialMediaButtons.propTypes = {
  containerClassName: _propTypes2.default.string,
  buttonClassName: _propTypes2.default.string,
  socialMediaConfig: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
};

SocialMediaButtons.defaultProps = {
  containerClassName: '',
  buttonClassName: ''
};